import { AwsUi } from '../../../../core/runtime/src';
import debounce from '../../../../core/utils/src/debounce';
import { any, applyClass, applyStyles, isMobileView } from './utils';
import Mezzanine from './mezzanine';
import Navigation from './navigation';
import Content from './content';
import Tools from './tools';
import defaults from './defaults';
var LayoutUpdater = /** @class */ (function () {
    function LayoutUpdater(component) {
        var _this = this;
        this.component = component;
        this.lastWindowWidth = window.innerWidth;
        this.resizeListener = debounce(function () {
            AwsUi.elementQueries.requestAnimationFrame(function () {
                _this.toggleNavigationIfNecessary();
                _this.updateLayout();
            });
        });
        this.node = component.node;
        this.layoutNode = component.node.querySelector('.awsui-app-layout');
        this.mezzanine = new Mezzanine(component);
        this.navigation = new Navigation(component, this.mezzanine);
        this.tools = new Tools(component, this.mezzanine);
        this.content = new Content(component);
        this.changeListener = function () {
            AwsUi.elementQueries.requestAnimationFrame(function () { return _this.updateLayout(); });
        };
    }
    LayoutUpdater.prototype.attach = function () {
        this.mezzanine.attach(this.changeListener);
        this.updateLayout();
        window.addEventListener('resize', this.resizeListener);
        window.addEventListener('load', this.changeListener);
    };
    LayoutUpdater.prototype.detach = function () {
        this.mezzanine.detach();
        window.removeEventListener('resize', this.resizeListener);
        window.removeEventListener('load', this.changeListener);
    };
    LayoutUpdater.prototype.updateLayout = function () {
        var isMobile = isMobileView();
        if (!isMobile) {
            if (this.component.navigationOpen === null || this.component.__navigationWasDefaulted) {
                // If user did not specify navigation state, we use the default one
                this.component.navigationOpen = defaults.get(this.component).navigationOpen;
                this.component.__navigationWasDefaulted = true;
            }
        }
        var hasChanged = any([
            this.navigation.update(isMobile),
            this.content.update(isMobile),
            this.tools.update(isMobile),
            applyClass(this.node, 'awsui-app-layout--mobile', isMobile),
            applyStyles(this.layoutNode, {
                height: "calc(100vh - " + this.mezzanine.getHeaderHeight() + "px - " + this.mezzanine.getFooterHeight() + "px)"
            })
        ]);
        // This flag is a primitive, will only trigger render on value change
        this.component.__isMobile = isMobile;
        if (hasChanged) {
            AwsUi.elementQueries.notifyChange();
        }
    };
    LayoutUpdater.prototype.toggleNavigationIfNecessary = function () {
        var isViewportShrinking = this.lastWindowWidth > window.innerWidth;
        if (isViewportShrinking && this.component.navigationOpen) {
            this.closeNavigationIfNecessary();
        }
        else {
            this.openNavigationIfNecessary();
        }
        this.lastWindowWidth = window.innerWidth;
    };
    LayoutUpdater.prototype.openNavigationIfNecessary = function () {
        var requiredSpace = this.component.navigationWidth + this.content.getMaxWidth() + this.tools.getWidth(this.component.__isMobile);
        if (requiredSpace < window.innerWidth) {
            this.component.__openNavigation();
        }
    };
    LayoutUpdater.prototype.closeNavigationIfNecessary = function () {
        var availableSpace = this.component.navigationWidth + this.content.getMinWidth() + this.tools.getWidth(this.component.__isMobile);
        if (this.component.__isMobile || availableSpace > window.innerWidth) {
            this.component.__closeNavigation();
        }
    };
    return LayoutUpdater;
}());
export default LayoutUpdater;
//# sourceMappingURL=updater.js.map